import { useAppState } from '../../client/providers/AppProvider';
import React from 'react';
import { NeedsOnboardingInformation, usePageRequireAuth } from '../../client/hooks';
import { DashboardLayout } from '../../components/common/layout/DashboardLayout';
import { PlayerMyEvents } from '../../components/dashboard/my-events/PlayerMyEvents';
import { PlayerMyEventsSkeleton } from '../../components/dashboard/my-events/PlayerMyEventsSkeleton';
import { Espin_Role_Enum } from '../../generated/spin-graphql';
import { FullPageComingSoon } from '../../components/sections/FullPageComingSoon';
import { ParentMyEvents } from '../../components/dashboard/my-events/ParentMyEvents';
import { HighSchoolMyEvents } from '../../components/dashboard/my-events/HighSchoolMyEvents';

export default function DashboardMyEvents() {
    const { user } = useAppState();
    usePageRequireAuth({});

    if (!!!user) {
        return (
            <DashboardLayout pageTitle="Events">
                <PlayerMyEventsSkeleton />
            </DashboardLayout>
        );
    }

    return (
        <DashboardLayout pageTitle="Events">
            <NeedsOnboardingInformation>
                {user.role === Espin_Role_Enum.EspinCollegeUser && <FullPageComingSoon />}
                {user.role === Espin_Role_Enum.EspinHighschoolUser && <HighSchoolMyEvents user={user} />}
                {user.role === Espin_Role_Enum.EspinPlayerUser && <PlayerMyEvents user={user} />}
                {/* todo - section this off. should be querying slightly different to get the child events */}
                {user.role === Espin_Role_Enum.EspinParentUser && <ParentMyEvents user={user} />}
            </NeedsOnboardingInformation>
        </DashboardLayout>
    );
}
